// extracted by mini-css-extract-plugin
export default {"bodyFlow":"Profile_bodyFlow__GVm5G"};